import dynamic from "next/dynamic"
const AlreadySubmitted = dynamic(() => import("./AlreadySubmitted"))
const AttorneyLoader = dynamic(() => import("./attorneyLoader"))
const BasicLoader = dynamic(() => import("./basicLoader"))
const BasicError = dynamic(() => import("./basicError"))
const Initialize = dynamic(() => import("./initialize"))
const SubmittedTicket = dynamic(() => import("./SubmittedTicket"))
const Info = dynamic(() => import("./Info"))


export const SCREEN_KEYS = {
  alreadySubmitted: 'alreadySubmitted',
  attorneyLoader: 'attorneyLoader',
  basicError: 'basicError',
  basicLoader: 'basicLoader',
  initialize: 'initialize',
  submittedTicket: 'submittedTicket',
  info: 'info'
}

const SCREENS = {
  [SCREEN_KEYS.alreadySubmitted]: AlreadySubmitted,
  [SCREEN_KEYS.attorneyLoader]: AttorneyLoader,
  [SCREEN_KEYS.basicError]: BasicError,
  [SCREEN_KEYS.basicLoader]: BasicLoader,
  [SCREEN_KEYS.Initialize]: Initialize,
  [SCREEN_KEYS.submittedTicket]: SubmittedTicket,
  [SCREEN_KEYS.info]: Info
}

export default SCREENS
